module.exports = __webpack_public_path__ + "static/media/SECTION.b24fdf47.svg";